import React, { useState } from 'react'
import { Icon } from '@chakra-ui/icons'
import { Box, Flex, Text } from '@chakra-ui/react'
import { Button } from '@chakra-ui/react'
import { FaTriangleExclamation } from 'react-icons/fa6'

import { useMessageProperties } from './message-provider'
import ExportSelectWrapper from './export-select-wrapper'
import UserMessage from './user-message'
import SystemMessage from './system-message'
import SharedStack from '~components/shared/wrappers/shared-stack'
import { MessageLocationTag } from '.'

export default function MessageErrorPreview({
    showLocationTag,
}: {
    showLocationTag?: boolean
}) {
    const { message, isSystemMsg } = useMessageProperties()
    const [showMessage, setShowMessage] = useState(false)

    if (showMessage) {
        return isSystemMsg ? (
            <SystemMessage showLocationTag={showLocationTag} />
        ) : (
            <UserMessage showLocationTag={showLocationTag} />
        )
    }

    return (
        <ExportSelectWrapper>
            <Box w="full">
                <Box
                    px={3}
                    py={2}
                    fontSize="sm"
                    bg="yellow.50"
                    color="gray.600"
                    borderRadius="xl"
                    borderWidth={1}
                    borderColor="yellow.200"
                    overflowWrap="anywhere"
                    overflow="hidden"
                    opacity={showLocationTag ? 0.7 : 1}
                    transition="opacity 0.2s ease-in-out"
                    _hover={
                        showLocationTag
                            ? {
                                  opacity: 1,
                              }
                            : {}
                    }
                >
                    <Flex>
                        <Icon
                            as={FaTriangleExclamation}
                            boxSize="18px"
                            mr={3}
                            mt="3px"
                            color="yellow.500"
                            flexShrink={0}
                        />
                        <Box w="full">
                            <Flex
                                alignItems="center"
                                justifyContent="space-between"
                                gap={2}
                            >
                                <SharedStack row fit>
                                    {showLocationTag && <MessageLocationTag />}
                                    <Text
                                        fontStyle="italic"
                                        fontSize="xs"
                                        color="gray.500"
                                    >
                                        This message was not delivered due to
                                        the following:
                                    </Text>
                                </SharedStack>
                                <Button
                                    size="xs"
                                    variant="ghost"
                                    colorScheme="yellow"
                                    flexShrink={0}
                                    onClick={() => setShowMessage(true)}
                                >
                                    Show message
                                </Button>
                            </Flex>
                            <Box mt={1}>
                                {message.email_error && (
                                    <Text color="yellow.700" fontSize="xs">
                                        {message.email_error}
                                    </Text>
                                )}
                                {message.sms_error && (
                                    <Text color="yellow.700" fontSize="xs">
                                        {message.sms_error}
                                    </Text>
                                )}
                                {message.postcard_error && (
                                    <Text color="yellow.700" fontSize="xs">
                                        {message.postcard_error}
                                    </Text>
                                )}
                                {!!message.other_errors?.length &&
                                    message.other_errors.map(error => (
                                        <Text
                                            color="yellow.700"
                                            fontSize="xs"
                                            key={error}
                                        >
                                            {error}
                                        </Text>
                                    ))}
                            </Box>
                        </Box>
                    </Flex>
                </Box>
            </Box>
        </ExportSelectWrapper>
    )
}
